var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlide3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 628,
    viewBox: "0 0 1200 628",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_3)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 628,
    fill: "#A6EEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200 0H0V628H1200V0Z",
    fill: "#A6EEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.6 122.8C100.6 122.8 70.2 147 60.8 180H212.5C203.1 147 172.7 122.8 136.6 122.8Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.6 122.8C307.6 122.8 277.2 147 267.8 180H419.5C410 147 379.6 122.8 343.6 122.8Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245 98.3C193.5 98.3 150.1 132.8 136.7 180H353.4C339.9 132.8 296.5 98.3 245 98.3Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1098.5 628C1104.5 608.8 1107.8 588.4 1107.8 567.2C1107.8 474.8 1045.9 396.8 961.2 372.5C967.2 358 970.5 342.1 970.5 325.4C970.5 257.2 915.2 201.9 847 201.9C835.3 201.9 823.9 203.5 813.2 206.6C767.5 133.1 686.1 84.2 593.2 84.2C473.1 84.2 372.1 166 342.9 276.9C203.7 281.2 92.2 395.4 92.2 535.6C92.2 568.2 98.2 599.3 109.2 628H1098.5Z",
    fill: "#7DE3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.6 459.7H377.9C371.9 459.7 367 454.8 367 448.8V169.6C367 163.6 371.9 158.7 377.9 158.7H578.6C584.6 158.7 589.5 163.6 589.5 169.6V448.7C589.6 454.8 584.7 459.7 578.6 459.7Z",
    fill: "#003057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.9 158.6H393.2V459.6H400.9V158.6Z",
    fill: "#006184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.9 239.6V200.7H491.7H479.5V239.6H442V251.9V264.1H479.5V367.1H491.7H503.9V264.1H541.4V251.9V239.6H503.9Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.1 211.5L440.9 199L420.7 211.5V151.4H461.1V211.5Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.5 175.2C698.7 175.2 682 188.5 676.8 206.6H760.2C755 188.5 738.3 175.2 718.5 175.2Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.2 175.2C812.4 175.2 795.7 188.5 790.5 206.6H873.9C868.7 188.5 852 175.2 832.2 175.2Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M778 161.7C749.7 161.7 725.8 180.7 718.4 206.6H837.5C830.2 180.7 806.3 161.7 778 161.7Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.3 505.3V382.9",
    stroke: "#006184",
    strokeWidth: 10,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.2 457L341.8 445.9",
    stroke: "#006184",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.2 501L217.8 489.9",
    stroke: "#006184",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.9 307.4C277.9 317.7 282.1 327 288.8 333.8C271.6 343.2 260 361.4 260 382.4C260 413 284.8 437.7 315.3 437.7V270C294.6 270 277.9 286.7 277.9 307.4Z",
    fill: "#369094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.8 333.8C348.5 327 352.7 317.7 352.7 307.4C352.7 286.7 336 270 315.3 270V437.7C345.9 437.7 370.6 412.9 370.6 382.4C370.6 361.4 359 343.2 341.8 333.8Z",
    fill: "#2F7D80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.9 351.4C153.9 361.7 158.1 371 164.8 377.8C147.6 387.2 136 405.4 136 426.4C136 457 160.8 481.7 191.3 481.7V314C170.6 314 153.9 330.7 153.9 351.4Z",
    fill: "#369094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.8 377.8C224.5 371 228.7 361.7 228.7 351.4C228.7 330.7 212 314 191.3 314V481.7C221.9 481.7 246.6 456.9 246.6 426.4C246.6 405.4 235 387.2 217.8 377.8Z",
    fill: "#2F7D80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.1 78.2C856.4 78.2 844 88.1 840.1 101.6H902.1C898.2 88.1 885.8 78.2 871.1 78.2Z",
    fill: "#7DE3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.6 78.2C940.9 78.2 928.5 88.1 924.6 101.6H986.6C982.7 88.1 970.3 78.2 955.6 78.2Z",
    fill: "#7DE3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915.3 68.2C894.3 68.2 876.5 82.3 871 101.6H959.5C954.1 82.3 936.4 68.2 915.3 68.2Z",
    fill: "#7DE3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.1 457.5C423.3 457.5 388 485.5 377.1 523.9H553.1C542.2 485.5 507 457.5 465.1 457.5Z",
    fill: "#369094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.7 429C291 429 240.6 469.1 225 523.8H476.4C460.8 469.1 410.5 429 350.7 429Z",
    fill: "#369094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.7 429C778 429 727.6 469.1 712 523.8H963.4C947.8 469.1 897.5 429 837.7 429Z",
    fill: "#369094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.8 171.8C126.5 171.8 107.8 186.7 101.9 207.1H195.6C189.8 186.7 171.1 171.8 148.8 171.8Z",
    fill: "#7DE3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.6 171.8C254.3 171.8 235.6 186.7 229.7 207.1H323.4C317.7 186.7 298.9 171.8 276.6 171.8Z",
    fill: "#7DE3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.7 156.6C183.9 156.6 157.1 177.9 148.8 207.1H282.6C274.3 178 247.5 156.6 215.7 156.6Z",
    fill: "#7DE3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.109 364C472.264 364 372.894 430.7 342.1 521.8H838C807.325 430.7 707.955 364 590.109 364Z",
    fill: "#369094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819 363.3C823.4 362.5 826.8 359.1 827.6 354.7C827.6 354.5 827.9 354.5 827.9 354.7C828.7 359.1 832.1 362.5 836.5 363.3C836.7 363.3 836.7 363.6 836.5 363.6C832.1 364.4 828.7 367.8 827.9 372.2C827.9 372.4 827.6 372.4 827.6 372.2C826.8 367.8 823.4 364.4 819 363.6C818.8 363.6 818.8 363.3 819 363.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.6 127.6C572 126.8 575.4 123.4 576.2 119C576.2 118.8 576.5 118.8 576.5 119C577.3 123.4 580.7 126.8 585.1 127.6C585.3 127.6 585.3 127.9 585.1 127.9C580.7 128.7 577.3 132.1 576.5 136.5C576.5 136.7 576.2 136.7 576.2 136.5C575.4 132.1 572 128.7 567.6 127.9C567.4 127.8 567.4 127.6 567.6 127.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.4 336.5C806.3 335.9 808.5 333.6 809.1 330.8C809.1 330.6 809.4 330.6 809.4 330.8C810 333.7 812.3 335.9 815.1 336.5C815.3 336.5 815.3 336.8 815.1 336.8C812.2 337.4 810 339.7 809.4 342.5C809.4 342.7 809.1 342.7 809.1 342.5C808.5 339.6 806.2 337.4 803.4 336.8C803.3 336.8 803.3 336.6 803.4 336.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.9 181.3C548.8 180.7 551 178.4 551.6 175.6C551.6 175.4 551.9 175.4 551.9 175.6C552.5 178.5 554.8 180.7 557.6 181.3C557.8 181.3 557.8 181.6 557.6 181.6C554.7 182.2 552.5 184.5 551.9 187.3C551.9 187.5 551.6 187.5 551.6 187.3C551 184.4 548.7 182.2 545.9 181.6C545.8 181.5 545.8 181.3 545.9 181.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M856.4 243.9C859.3 243.3 861.5 241 862.1 238.2C862.1 238 862.4 238 862.4 238.2C863 241.1 865.3 243.3 868.1 243.9C868.3 243.9 868.3 244.2 868.1 244.2C865.2 244.8 863 247.1 862.4 249.9C862.4 250.1 862.1 250.1 862.1 249.9C861.5 247 859.2 244.8 856.4 244.2C856.3 244.2 856.3 243.9 856.4 243.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.1 349.7C242 349.1 244.2 346.8 244.8 344C244.8 343.8 245.1 343.8 245.1 344C245.7 346.9 248 349.1 250.8 349.7C251 349.7 251 350 250.8 350C247.9 350.6 245.7 352.9 245.1 355.7C245.1 355.9 244.8 355.9 244.8 355.7C244.2 352.8 241.9 350.6 239.1 350C238.9 349.9 238.9 349.7 239.1 349.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.172 63.7V49H668.572H663.972V63.7H649.872V68.3V72.9H663.972V111.8H668.572H673.172V72.9H687.372V68.3V63.7H673.172Z",
    fill: "#006184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.872 417.4H610.372V158.7L668.572 103.4L726.872 158.7V417.4Z",
    fill: "#006184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.872 431.4H610.372V172.7L668.572 117.4L726.872 172.7V431.4Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.072 295.1V455.8H552.072V295.1L668.572 251.5L785.072 295.1Z",
    fill: "#006184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.072 309.1V455.8H552.072V309.1L668.572 265.5L785.072 309.1Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.972 455.8H626.172V378.5C626.172 355.1 645.172 336.1 668.572 336.1C691.972 336.1 710.972 355.1 710.972 378.5V455.8Z",
    fill: "#006184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.972 378.6V449.9H632.172V378.7C632.172 358.6 648.472 342.3 668.572 342.3C675.172 342.3 681.372 344.1 686.672 347.1C687.972 347.9 689.272 348.7 690.472 349.6C693.372 351.8 695.972 354.4 698.072 357.4C698.972 358.6 699.772 359.9 700.572 361.3C702.472 364.8 703.872 368.7 704.472 372.7C704.872 374.6 704.972 376.6 704.972 378.6Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.572 319.7C679.342 319.7 688.072 310.97 688.072 300.2C688.072 289.43 679.342 280.7 668.572 280.7C657.803 280.7 649.072 289.43 649.072 300.2C649.072 310.97 657.803 319.7 668.572 319.7Z",
    fill: "#006184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.572 313.7C676.028 313.7 682.072 307.656 682.072 300.2C682.072 292.744 676.028 286.7 668.572 286.7C661.116 286.7 655.072 292.744 655.072 300.2C655.072 307.656 661.116 313.7 668.572 313.7Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.772 235.4H647.372V175.4C647.372 163.7 656.872 154.2 668.572 154.2C680.272 154.2 689.772 163.7 689.772 175.4V235.4Z",
    fill: "#006184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.372 229.4V175.4C653.372 167 660.172 160.2 668.572 160.2C676.972 160.2 683.772 167 683.772 175.4V229.4H653.372Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.172 160.2L668.572 176.8V229.4",
    stroke: "#006184",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.972 160.2L668.572 176.8V229.4",
    stroke: "#006184",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.872 338.9H666.372V450.1H670.872V338.9Z",
    fill: "#006184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M802.1 455H535.1V480H802.1V455Z",
    fill: "#006184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.1 468H521.1V480H815.1V468Z",
    fill: "#003057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.6 513.8C1004.6 488.5 984.1 468 958.8 468C933.5 468 913 488.5 913 513.8C913 526.7 918.3 538.3 926.8 546.6H990.6C999.2 538.3 1004.6 526.7 1004.6 513.8Z",
    fill: "#2F7D80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.7 457.8C580.7 432.5 560.2 412 534.9 412C509.6 412 489.1 432.5 489.1 457.8C489.1 470.7 494.4 482.3 502.9 490.6H566.7C575.3 482.3 580.7 470.7 580.7 457.8Z",
    fill: "#2F7D80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.2 471.1C615.2 456.1 603 443.9 588 443.9C573 443.9 560.8 456.1 560.8 471.1C560.8 478.7 564 485.7 569 490.6H607C612.1 485.6 615.2 478.7 615.2 471.1Z",
    fill: "#2F7D80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892 257.1C858.9 257.1 831.1 279.3 822.4 309.5H961.5C953 279.2 925.1 257.1 892 257.1Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1081.8 257.1C1048.7 257.1 1020.9 279.3 1012.2 309.5H1151.3C1142.8 279.2 1114.9 257.1 1081.8 257.1Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.4 234.6C944.2 234.6 904.4 266.3 892 309.5H1090.7C1078.4 266.3 1038.6 234.6 991.4 234.6Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.6 254.5C787.3 252.2 783.5 252.2 781.2 254.5C778.9 256.8 778.9 260.6 781.2 262.9L790.2 271.9V255.1L789.6 254.5Z",
    fill: "#FC4E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790.9 254.5C793.2 252.2 797 252.2 799.3 254.5C801.6 256.8 801.6 260.6 799.3 262.9L790.3 271.9V255.1L790.9 254.5Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 939,
    y1: 540,
    x2: 181,
    y2: 540,
    stroke: "#006184",
    strokeWidth: 40,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881.3 529.3V406.9",
    stroke: "#003057",
    strokeWidth: 10,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820 221.3C817.7 219 813.9 219 811.6 221.3C809.3 223.6 809.3 227.4 811.6 229.7L820.6 238.7V221.9L820 221.3Z",
    fill: "#FC4E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.2 221.3C823.5 219 827.3 219 829.6 221.3C831.9 223.6 831.9 227.4 829.6 229.7L820.6 238.7V221.9L821.2 221.3Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881.2 481L907.8 469.9",
    stroke: "#003057",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.6 114.9C755.3 112.6 751.5 112.6 749.2 114.9C746.9 117.2 746.9 121 749.2 123.3L758.2 132.3V115.5L757.6 114.9Z",
    fill: "#FC4E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.8 114.9C761.1 112.6 764.9 112.6 767.2 114.9C769.5 117.2 769.5 121 767.2 123.3L758.2 132.3V115.5L758.8 114.9Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.9 331.4C843.9 341.7 848.1 351 854.8 357.8C837.6 367.2 826 385.4 826 406.4C826 437 850.8 461.7 881.3 461.7V294C860.6 294 843.9 310.7 843.9 331.4Z",
    fill: "#369094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M907.8 357.8C914.5 351 918.7 341.7 918.7 331.4C918.7 310.7 902 294 881.3 294V461.7C911.9 461.7 936.6 436.9 936.6 406.4C936.6 385.4 925 367.2 907.8 357.8Z",
    fill: "#2F7D80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.241 537.908C540.057 537.908 539.872 537.908 539.687 537.908C538.302 537.815 537.195 536.523 537.379 535.138L538.949 516.673C539.041 515.288 540.334 514.18 541.718 514.365C543.103 514.457 544.211 515.75 544.027 517.135L542.457 535.6C542.457 536.8 541.441 537.815 540.241 537.908Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.179 533.568C536.179 533.568 534.979 540.308 536.64 540.401C538.21 540.493 561.291 539.662 561.291 538.554C561.476 534.861 542.549 532.738 540.703 533.292C538.949 533.753 536.363 532.645 536.179 533.568Z",
    fill: "#1A1C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.093 537.723C571.909 537.815 571.724 537.815 571.632 537.815C570.247 538 568.954 536.985 568.77 535.6L566.462 517.227C566.277 515.842 567.292 514.55 568.677 514.365C570.062 514.18 571.355 515.196 571.539 516.581L573.847 534.953C573.94 536.246 573.201 537.354 572.093 537.723Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.939 533.568C567.939 533.568 566.738 540.308 568.4 540.401C569.97 540.493 593.051 539.662 593.051 538.554C593.236 534.861 574.309 532.738 572.463 533.292C570.616 533.753 568.031 532.645 567.939 533.568Z",
    fill: "#1A1C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.348 286.508C618.348 286.508 621.395 273.582 624.441 272.105C627.488 270.72 625.919 283.369 620.287 289.093L618.348 286.508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.24 284.938C618.994 286.139 620.841 287.246 622.595 288.354C605.422 316.883 587.419 325.653 555.475 318.914C550.582 317.898 550.397 316.144 551.597 312.174C551.043 311.62 551.043 311.712 551.597 312.174C552.89 308.204 554.09 307.65 559.075 308.758C591.481 315.405 595.821 309.958 617.24 284.938Z",
    fill: "#1A1C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.902 527.475C538.764 527.383 571.078 526.367 573.847 525.536C568.77 477.527 565.261 389.357 565.723 389.08C564.707 371.539 560.83 341.718 561.753 324.269C561.938 320.391 562.584 318.267 561.938 315.221C559.999 306.081 552.428 303.311 544.396 307.373C543.934 307.558 536.918 310.789 536.456 323.345C535.902 339.779 537.471 352.797 540.611 367.292C540.611 367.292 540.611 367.292 540.611 367.384C537.656 420.471 539.872 475.219 535.902 527.475Z",
    fill: "#1A1C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.149 398.036C540.149 398.036 545.319 411.054 543.565 414.1C541.811 417.147 535.533 405.33 536.917 397.02L540.149 398.036Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.887 398.59C538.856 399.421 536.825 400.067 534.886 400.806C521.592 362.306 515.498 347.442 538.025 313.19C541.441 307.927 542.365 309.22 545.781 311.897C546.612 311.528 546.704 311.62 545.781 311.897C549.289 314.667 549.751 315.498 545.965 320.576C521.407 353.72 532.855 359.444 540.887 398.59Z",
    fill: "#1A1C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.842 293.063C546.796 300.264 554.275 304.05 558.614 302.295C563.045 300.449 562.768 293.709 559.814 286.508C556.86 279.307 551.782 277.091 547.35 278.845C542.919 280.691 540.888 285.862 543.842 293.063Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.303 293.524L552.428 292.14C552.613 293.247 554.275 303.772 554.09 307.835C553.905 309.127 551.874 309.774 549.658 309.404C547.627 309.035 546.15 307.927 545.965 306.819C546.058 304.419 545.042 297.31 544.303 293.524Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.845 294.355C561.845 294.355 561.753 294.355 561.568 294.448C559.999 294.909 552.982 297.31 551.874 299.803C550.582 302.665 555.475 299.341 557.137 297.679C558.706 296.017 560.183 296.571 561.661 296.387C562.953 296.202 563.969 294.632 561.845 294.355Z",
    fill: "#1A1C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.626 296.848C542.272 298.51 544.857 299.987 546.058 299.526C547.258 299.064 546.981 297.494 546.335 295.833C545.688 294.171 544.026 292.971 542.826 293.524C541.626 293.986 540.887 295.186 541.626 296.848Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.887 288.908C540.887 288.908 540.518 283.646 543.473 280.507C546.427 277.368 553.536 274.783 557.598 280.599C557.598 280.599 560.183 284.938 554.644 287.616C549.104 290.293 549.104 286.877 547.258 290.662C545.411 294.448 542.088 293.155 541.811 293.986L540.887 288.908Z",
    fill: "#1A1C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.12 305.065C547.812 305.065 545.688 304.696 544.303 304.049V309.681H555.105V304.326C553.813 304.788 552.059 305.065 550.12 305.065Z",
    fill: "#1A1C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.536 305.527H550.951V311.066H553.536V305.527Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.297 402H413.992C424.362 402 432.708 410.346 432.708 420.716V491.028H437.766C445.354 491.028 451.424 497.098 451.424 504.686V531.748H426.891H183.834H178.017V525.931V490.775V426.533C177.511 413.129 188.639 402 202.297 402Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 508,
    width: 274,
    height: 24,
    fill: "#FF7975"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 508,
    width: 274,
    height: 12,
    fill: "#F04160"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.233 531.748C413.233 522.137 405.392 514.297 395.781 514.297C386.17 514.297 378.33 522.137 378.33 531.748C378.33 541.359 386.17 549.2 395.781 549.2C405.392 549.2 413.233 541.359 413.233 531.748Z",
    fill: "#1A1C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.782 540.601C390.893 540.601 386.929 536.637 386.929 531.748C386.929 526.859 390.893 522.896 395.782 522.896C400.671 522.896 404.634 526.859 404.634 531.748C404.634 536.637 400.671 540.601 395.782 540.601Z",
    fill: "#006184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.27 531.748C243.27 522.137 235.43 514.297 225.819 514.297C216.208 514.297 208.367 522.137 208.367 531.748C208.367 541.359 216.208 549.2 225.819 549.2C235.43 549.2 243.27 541.359 243.27 531.748Z",
    fill: "#1A1C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.311 490.775H417.027C419.556 490.775 421.327 488.752 421.327 486.476V461.942C421.327 459.413 419.303 457.643 417.027 457.643H398.311C395.782 457.643 394.011 459.666 394.011 461.942V486.476C393.758 489.005 395.782 490.775 398.311 490.775Z",
    fill: "#A6EEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.311 446.514H417.027C419.556 446.514 421.327 444.491 421.327 442.214V417.681C421.327 415.152 419.303 413.381 417.027 413.381H398.311C395.782 413.381 394.011 415.405 394.011 417.681V442.214C393.758 444.491 395.782 446.514 398.311 446.514Z",
    fill: "#A6EEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.396 490.775H381.112C383.641 490.775 385.412 488.752 385.412 486.476V461.942C385.412 459.413 383.388 457.643 381.112 457.643H362.396C359.867 457.643 358.096 459.666 358.096 461.942V486.476C357.843 489.005 359.867 490.775 362.396 490.775Z",
    fill: "#A6EEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.396 446.514H381.112C383.641 446.514 385.412 444.491 385.412 442.214V417.681C385.412 415.152 383.388 413.381 381.112 413.381H362.396C359.867 413.381 358.096 415.405 358.096 417.681V442.214C357.843 444.491 359.867 446.514 362.396 446.514Z",
    fill: "#A6EEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.228 490.775H344.944C347.474 490.775 349.244 488.752 349.244 486.476V461.942C349.244 459.413 347.221 457.643 344.944 457.643H326.228C323.699 457.643 321.929 459.666 321.929 461.942V486.476C321.929 489.005 323.952 490.775 326.228 490.775Z",
    fill: "#A6EEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.228 446.514H344.944C347.474 446.514 349.244 444.491 349.244 442.214V417.681C349.244 415.152 347.221 413.381 344.944 413.381H326.228C323.699 413.381 321.929 415.405 321.929 417.681V442.214C321.929 444.491 323.952 446.514 326.228 446.514Z",
    fill: "#A6EEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.313 490.775H309.03C311.559 490.775 313.329 488.752 313.329 486.476V461.942C313.329 459.413 311.306 457.643 309.03 457.643H290.313C287.784 457.643 286.014 459.666 286.014 461.942V486.476C286.014 489.005 288.037 490.775 290.313 490.775Z",
    fill: "#A6EEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.313 446.514H309.03C311.559 446.514 313.329 444.491 313.329 442.214V417.681C313.329 415.152 311.306 413.381 309.03 413.381H290.313C287.784 413.381 286.014 415.405 286.014 417.681V442.214C286.014 444.491 288.037 446.514 290.313 446.514Z",
    fill: "#A6EEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.399 490.775H273.115C275.644 490.775 277.415 488.752 277.415 486.476V461.942C277.415 459.413 275.391 457.643 273.115 457.643H254.399C251.869 457.643 250.099 459.666 250.099 461.942V486.476C250.099 489.005 252.122 490.775 254.399 490.775Z",
    fill: "#A6EEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.399 446.514H273.115C275.644 446.514 277.415 444.491 277.415 442.214V417.681C277.415 415.152 275.391 413.381 273.115 413.381H254.399C251.869 413.381 250.099 415.405 250.099 417.681V442.214C250.099 444.491 252.122 446.514 254.399 446.514Z",
    fill: "#A6EEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.484 490.775H237.2C239.73 490.775 241.5 488.752 241.5 486.476V461.942C241.5 459.413 239.477 457.643 237.2 457.643H218.484C215.955 457.643 214.185 459.666 214.185 461.942V486.476C214.185 489.005 216.208 490.775 218.484 490.775Z",
    fill: "#A6EEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.484 446.514H237.2C239.73 446.514 241.5 444.491 241.5 442.214V417.681C241.5 415.152 239.477 413.381 237.2 413.381H218.484C215.955 413.381 214.185 415.405 214.185 417.681V442.214C214.185 444.491 216.208 446.514 218.484 446.514Z",
    fill: "#A6EEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.819 540.601C220.93 540.601 216.967 536.637 216.967 531.748C216.967 526.859 220.93 522.896 225.819 522.896C230.708 522.896 234.671 526.859 234.671 531.748C234.671 536.637 230.708 540.601 225.819 540.601Z",
    fill: "#006184"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 628,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlide3);
export default __webpack_public_path__ + "static/media/slide3.9686b7ac05d7e04c594f77429fa3669b.svg";
export { ForwardRef as ReactComponent };